import * as React from 'react';

import { UrlHelpers } from '../../service/UrlHelpers';
import { CampaignType } from '../../typings/domain';

import './CampaignEditFrame.css';

export type CampaignEditFrameProps = {
    campaignId?: string;
    campaignType?: CampaignType;
    login: string;
    onLoad?: () => void;
};

export class CampaignEditFrame extends React.PureComponent<CampaignEditFrameProps> {
    render() {
        const { login, onLoad } = this.props;
        let url;

        if (onLoad === undefined) {
            return null;
        }

        if (this.props.campaignId !== undefined) {
            url = UrlHelpers.getDirectLink('editCamp', {
                ...UrlHelpers.getEditCampUrlParams(this.props.campaignId, login),
                popupMode: '1'
            });
        } else {
            url = UrlHelpers.getDirectLink('editCamp', {
                ...UrlHelpers.getAddCampUrlParams(this.props.campaignType as CampaignType, login),
                popupMode: '1'
            });
        }

        return <iframe className={'campaign-edit-frame'} frameBorder="0" src={url} onLoad={e => onLoad()} />;
    }
}
